'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectYear = exports.reducerIndex = undefined;

var _actions = require('./db/actions');

Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});

var _select = require('./db/select');

Object.keys(_select).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _select[key];
    }
  });
});

var _redux = require('redux');

var _reducer = require('./reducer');

var reducerIndex = _interopRequireWildcard(_reducer);

var _session = require('./session');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.reducerIndex = reducerIndex;
exports.selectYear = _session.selectYear;

var reducer = (0, _redux.combineReducers)(reducerIndex);

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-reducer/lib/index.js
// module id = 235
// module chunks = 0